var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('address', {
    staticClass: "address-info"
  }, [_c('div', {
    staticClass: "contact_item_loc"
  }, [_vm._v("Ut interdum tristique est com modo pharetra.")]), _vm._v(" "), _c('div', {
    staticClass: "contact_item_tel"
  }, [_c('a', {
    attrs: {
      "href": "tel:11156985698"
    }
  }, [_vm._v("111 5698 5698")])]), _vm._v(" "), _c('div', {
    staticClass: "contact_item_mail"
  }, [_c('a', {
    attrs: {
      "href": "mailto:modus@versus.com"
    }
  }, [_vm._v("modus@versus.com")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21ecc651","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/address-info/address-info.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-21ecc651","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/address-info/address-info.vue
// module chunks = index